import { t } from 'helpers/i18n';
import React, { memo } from 'react';
import './ReadOnlyTextView.scss';

type ReadOnlyTextViewProps = {
  label: string;
  value?: string;
  className?: string;
};

const ReadOnlyTextView: React.FC<ReadOnlyTextViewProps> = ({
  label,
  value,
  className,
}) => {
  return (
    <div className={className}>
      <p className="read-only-text-view-label ds-typo-subtitle2">{label}</p>
      {value ? (
        <p className="read-only-text-view-value-text mt-8">{value}</p>
      ) : (
        <p className="read-only-text-view-no-value-text">
          {t('read_only_text_view_empty_value')}
        </p>
      )}
    </div>
  );
};

export default memo(ReadOnlyTextView);
